module.exports = __webpack_public_path__ + "img/AddPhotoAlternateOutlined.6341264c.svg";